import React from 'react';

type Props = {
  label: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
};

export default function FilterSelect({ label, htmlFor, children, className = '' }: Props) {
  return (
    <label className={`ui-filter ${className}`.trim()} htmlFor={htmlFor}>
      <span className="ui-filter__label">{label}</span>
      {children}
    </label>
  );
}
